import { useEffect } from "react";

const dirtySources = new Set<symbol>();

/** True while any mounted component has reported unsaved changes. */
export const hasUnsavedChanges = (): boolean => dirtySources.size > 0;

/**
 * Lets app-level UI (e.g. the session-expired dialog) know this component
 * holds work that would be lost if the page navigated away.
 */
export const useUnsavedChanges = (isDirty: boolean): void => {
  useEffect(() => {
    if (!isDirty) return;
    const source = Symbol("unsaved-changes");
    dirtySources.add(source);
    return () => {
      dirtySources.delete(source);
    };
  }, [isDirty]);
};
